import React, { useEffect, useState } from 'react';
import API_BASE_URL from "Components/API";
import Loading from "Components/Loading";
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
import axios from 'axios';
import parse from 'html-react-parser';
import CalendarImg from "Assets/Images/calendar.png"
import LogoGray from "Assets/icons/logo-gray.svg"

const Calendar = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    return (
        <div className="megaMenuContent">
            <div className="row h-100">

                {/* LEFT TEXT COLUMN */}
                <div className="col-8 d-flex flex-column">

                    <p className="pt-5">
                        {currentLang === "fa" && (
                            <>
                                در این قسمت می‌توانید
                                <strong className="fw-bold"> تقویم رویداد‌ها، اولین معاملات و پذیرش‌های بورس انرژی ایران </strong>
                                را مشاهده کنید
                            </>
                        )}

                        {currentLang === "en" && (
                            <>
                                Here you can view the
                                <strong className="fw-bold"> event calendar, first trades, and listings of the Iran Energy Exchange </strong>.
                            </>
                        )}

                        {currentLang === "ar" && (
                            <>
                                هنا يمكنك عرض
                                <strong className="fw-bold"> تقويم الأحداث، وأول الصفقات، وعمليات الإدراج في بورصة الطاقة الإيرانية </strong>.
                            </>
                        )}
                    </p>
                    {/* VIEW TIMELINE BUTTON → pinned to bottom */}
                    <div className="mt-auto align-self-start">
                        <a
                            href="/Calendar"
                            target="_blank"
                            className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1"
                        >
                            {t('view_timeline')}
                            <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                                {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}   
                            </span>
                        </a>
                    </div>
                </div>

                {/* RIGHT IMAGE COLUMN (sets height reference) */}
                <div className="col-4 d-flex justify-content-center align-items-center">
                    <img
                        src={CalendarImg}
                        className="mx-auto max-width-100"
                        alt={t('energy_exchange')}
                    />
                </div>

            </div>
        </div>
    );
};

export default Calendar;
